<template>
  <div class="f18-l21-m margin-top-25 ">{{ this.text }}</div>
</template>
<script>
export default {
  props: ["text"]
}
</script>